import React from 'react'

import styles from '../../../Products.module.scss'

import CustomSelect from 'components/elements/inputs/CustomSelect'
import InputGroup from 'components/elements/forms/InputGroup'
import { ISelectOption } from 'components/elements/inputs/CustomSelect/CustomSelect'
// import CustomButton from 'components/elements/buttons/CustomButton'
import ProxyConfigurationForm from '../../ProxyConfigurationForm'
import { ProxyPoolDescription } from 'utils/proxy/proxyConstants'
import { SettingsAdjust as SettingsIcon } from '../../../../../icons'

interface IProxyListConfigurationProps {
  selectedProxyType: any
  selectedTimeInterval: any
  customTimeInterval: string
  selectedCountry: any
  selectedRegion: any
  selectedCity: any
  selectedIsp: any
  isBindIPActive: boolean
  selectedBindTtl: any
  customBindTtl: string
  activeSessionLengthType: any
  sessionPrefix: string
  selectedProxyModifier: string
  // connectionsAmount: number
  proxyTypesOptions: ISelectOption[]
  availableSessionIntervals: ISelectOption[]
  onProxyTypeChange: (option: ISelectOption) => void
  onCountryChange: (option: ISelectOption) => void
  onRegionChange: (option: ISelectOption) => void
  onCityChange: (option: ISelectOption) => void
  onIspChange: (option: ISelectOption) => void
  onTimeIntervalChange: (option: ISelectOption) => void
  onDeepTargetsReset: () => void
  onCustomTimeIntervalChange: (val: string) => void
  onBindIp: () => void
  onBindTtlChange: (option: ISelectOption) => void
  onCustomBindTtlChange: (val: string) => void
  onActiveSessionLengthChange: (e: any) => void
  onSessionPrefixChange: (e: any) => void
  onProxyModifierChange: (val: string) => void
  onGenerateIpClick: () => void
  // onConnectionsAmountChange: (e: any) => void
  // onGenerate: () => void
}

const ProxyListConfiguration: React.FC<IProxyListConfigurationProps> = (
  props
) => {
  const {
    selectedProxyType,
    selectedCountry,
    selectedRegion,
    selectedCity,
    selectedIsp,
    selectedTimeInterval,
    customTimeInterval,
    isBindIPActive,
    selectedBindTtl,
    customBindTtl,
    activeSessionLengthType,
    sessionPrefix,
    proxyTypesOptions,
    availableSessionIntervals,
    selectedProxyModifier,
    // connectionsAmount,
    onProxyTypeChange,
    onCountryChange,
    onRegionChange,
    onCityChange,
    onIspChange,
    onDeepTargetsReset,
    onTimeIntervalChange,
    onCustomTimeIntervalChange,
    onBindIp,
    onBindTtlChange,
    onCustomBindTtlChange,
    onActiveSessionLengthChange,
    onSessionPrefixChange,
    onProxyModifierChange,
    onGenerateIpClick,
    // onConnectionsAmountChange,
    // onGenerate,
  } = props

  const handleProxyTypeChange = (option: any) => {
    onProxyTypeChange(option)
  }

  return (
    <>
      <div className={styles.blockHeader}>
        <div className={styles.headerIconWrapper}>
          <SettingsIcon />
        </div>
        <span className={styles.blockTitle}>Connection setup</span>
      </div>

      <InputGroup
        className={styles.proxyTypeGroup}
        labelTop={'Proxy type'}
        boldLabel
        name={'pool_select_group'}
        description={ProxyPoolDescription}
      >
        <CustomSelect
          onChange={handleProxyTypeChange}
          value={selectedProxyType}
          name={'proxy-type-select'}
          isSearchable={false}
          options={proxyTypesOptions}
        />
      </InputGroup>

      <div className={styles.formWrapper}>
        <ProxyConfigurationForm
          settingsSection={'proxy_list'}
          selectedProxyType={selectedProxyType}
          // isConnectionsShown={true}
          selectedCountry={selectedCountry}
          selectedRegion={selectedRegion}
          selectedCity={selectedCity}
          selectedIsp={selectedIsp}
          activeSessionLengthType={activeSessionLengthType}
          selectedTimeInterval={selectedTimeInterval}
          customTimeInterval={customTimeInterval}
          isBindIPActive={isBindIPActive}
          selectedBindTtl={selectedBindTtl}
          customBindTtl={customBindTtl}
          sessionPrefix={sessionPrefix}
          selectedProxyModifier={selectedProxyModifier}
          // connectionsAmount={connectionsAmount}
          availableTimeIntervals={availableSessionIntervals}
          onCountryChange={onCountryChange}
          onRegionChange={onRegionChange}
          onCityChange={onCityChange}
          onIspChange={onIspChange}
          onDeepTargetsReset={onDeepTargetsReset}
          onActiveSessionLengthChange={onActiveSessionLengthChange}
          onTimeIntervalChange={onTimeIntervalChange}
          onCustomTimeIntervalChange={onCustomTimeIntervalChange}
          onBindIp={onBindIp}
          onBindTtlChange={onBindTtlChange}
          onCustomBindTtlChange={onCustomBindTtlChange}
          onSessionPrefixChange={onSessionPrefixChange}
          onProxyModifierChange={onProxyModifierChange}
          onGenerateIpClick={onGenerateIpClick}
          // onConnectionsAmountChange={onConnectionsAmountChange}
        />
      </div>

      {/*<CustomButton onClick={onGenerate} wide>
        Generate
      </CustomButton>*/}
    </>
  )
}

export default ProxyListConfiguration
